import { post } from "@shared/core/io";
import { afterGateway, onceOnlyInMemory as cachify } from "./gw-helper";

/**
 *
 * @param {String} char a or d or A or D
 * @returns {String}
 */
function adCharsMapper(char) {
  const map = { a: "~d", d: "~a", A: "~D", D: "~A" };
  return map[char];
}

/**
 *
 * @param {String} chars ad or Ad or AD or aD
 * @returns {String}
 */
function adCharsReplacer(chars) {
  return chars
    .split("")
    .map(adCharsMapper)
    .join("");
}

function prettifyAdPath(path) {
  return "/gw/~da" + path.replace(/ad/gi, adCharsReplacer);
}

export function getAdsBySlotId_raw(slotId) {
  return afterGateway(post(prettifyAdPath("/ad/api/v1/ad/getAdsBySlotId"), { adSlotId: slotId }));
}

export const getAdsBySlotId = cachify(getAdsBySlotId_raw);
